import React, { Component } from 'react'; //different
import Footer from './footer';
import instance from "./axios-instance";
import SweetAlert from 'react-bootstrap-sweetalert';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { t } from './i18n';
class App extends Component {
    get lang() { return localStorage.getItem('lang') || 'th'; }

    constructor(props) {
        super(props)
        this.state = {
            rewardlist: [],
            activePage: 1,
            isActive: false,
            categorylist: [],
            activeTab: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            pagecount: 1,
            username: null,
            userid: null,
            showpass: true,
            point: 0,
            balance: 0,
            products_page_count: 1,
            loginstate: false,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            token: window.localStorage.getItem("token"),
            type: "",
            linelink: "",
            amount: "",
            remark: "",
            name: "",
            password: "",
            left: false,
        }
        this.login = this.login.bind(this);
    }
    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }
    login = (e) => {
        console.log(55665);
        e.preventDefault();
        let errors = this.validateLoginForm();
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    validateLoginForm = async (e) => {
        const { username, password } = this.state;
        console.log(username, password);
        await instance.post("/api/v1/userlogin", {
            userid: username,
            password: password,
            System: Systems,
            Function: 'validateLoginForm-navbar.js'
        })
            .then(async (res) => {
                console.log(res);
                if (res.data.status === 200) {
                    await localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        firstname: res.data.message.firstname,
                        lastname: res.data.message.lastname,
                        point: res.data.message.Point,
                        balance: res.databalance,
                        loginstate: true,
                    });
                    await this.notify("success", t(this.lang, 'login_redirecting'));
                    setTimeout(() => { window.location.href = '/' }, 2000)
                }
                else if (res.data.status === 401) {
                    Swal.fire({
                        title: 'error!',
                        text: t(this.lang, 'ln_wrong_cred'),
                        icon: 'error',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                }
                else {
                    Swal.fire({
                        title: 'error!',
                        text: t(this.lang, 'ln_wrong_cred'),
                        icon: 'error',
                        confirmButtonText: t(this.lang, 'ok')
                    })
                    //   Bonn.alert("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง")
                }

            });
    }
    async componentDidMount() {

        try {
            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    this.setState({
                        linelink: datas[1].value,
                        System: res.data.tblcatagoryx[0].System
                    });
                }
            });
        }
        catch (error) {
            //////console.log();
        }
    }
    onChange = event => {
        let nam;
        let val;
        if (event.target.name === undefined) {
            // //////console.log("undefined", event.target);
            nam = event.name;
            val = event.value;
        } else {
            // //////console.log("event", event.target);
            nam = event.target.name;
            val = event.target.value;
        }
        this.setState({ [nam]: val });

    };

    render() {
        return (
            <div className="tt_l tt_full p_member">
                <div id="ct_from" className="tt_l tt_full title_page">
                    <h1>{t(this.lang, 'login')}</h1>
                </div>
                <div className="tt_l tt_full tt_content bg_tr">
                    <div className="tt_l tt_full">
                        <div className="tt_l tt_full">
                            {/*- if not login-*/}
                            <div className="tt_l tt_full fr_login fr_login_form" id="fr_login_form">
                                <div className="fr_center">
                                    <style
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                '\n  #btn-linelogin:before {\n    position: absolute;\n    font-family: "Font Awesome 5 Brands";\n    content: "\\f3c0";\n    margin-left: -41px;\n    font-size: 36px;\n    top: -4px;\n}\n  \n.btn-success-line {\n      display: inline-block;\n    font-weight: 400;\n    color: #212529;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    border-radius: .25rem;\n    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n    height: 48px;\n    background-color: #00b900;\n    border-color: #00b900;\n  border-radius: 5px;\n      padding-left: 47px;\n  cursor: pointer;\n  margin-top: .25rem!important;\n  display: block;\n    width: 100%;\n color: #fff;\n  position: relative;\n}\n  \n  #linelogin-c {\n    display: block;\n    position: relative;\n    height: 50px;\n}\n  \n  #linelogin-c:before {\n    content: \'\';\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 50%;\n    border-top: 1px solid #151515;\n}\n  \n  #linelogin-c::after {\n    text-align: center!important;\n    font-size: 18px;\n    content: "หรือ";\n    position: absolute;\n    width: 80px;\n    left: calc(50% - 40px);\n    height: 100%;\n    line-height: 300%;   \n    background-color: white;\n}\n  \n'
                                        }}
                                    />
                                    <a
                                        style={{ displayxx: "none", paddingTop: 10 }}
                                        className="  btn-success-line "
                                        type="button"
                                        id="btn-linelogin"
                                    >
                                        {t(this.lang, 'ufa_login_with_line')}
                                    </a>
                                    <div style={{ displaxx: "none" }} id="linelogin-c" />
                                    <form
                                        id="loginform"
                                        className=""
                                        method="POST"
                                    >
                                        <div className="tt_l fr_input">
                                            <input
                                                id="username"
                                                name="username"
                                                onChange={this.onChange}
                                                className="form-control tt_fr"
                                                maxLength={10}
                                                minLength={10}
                                                type="text"
                                                placeholder={t(this.lang, 'ufa_phone_placeholder_full')}
                                            />
                                            <input
                                                className="form-control tt_fr"
                                                maxLength={24}
                                                id="password"
                                                name="password"
                                                onChange={this.onChange}
                                                placeholder={t(this.lang, 'ufa_password_placeholder')}
                                            />
                                        </div>
                                        <input type="hidden" name="task" defaultValue="login" />
                                        <a onClick={(e) => {
                                            this.login(e)
                                        }} className="tt_r fr_submit" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} type="submit">
                                            <i className="fas fa-sign-in-alt" style={{ marginRight: 8 }} /> {t(this.lang, 'login')}
                                        </a>
                                    </form>
                                </div>
                            </div>
                            <link
                                href="/wp-content/themes/UFAC4.COM/css/icon.min.css"
                                rel="stylesheet"
                                type="text/css"
                            />
                            <div
                                className="tt_l tt_full fr_login center"
                                id="fr_login_user_form"
                                style={{ display: "none" }}
                            >
                                <div className="fr_uc">
                                    <span className="tt_l tt_full fr_tx_u">
                                        {t(this.lang, 'u3_member_id_is')} <span id="user_" /> (
                                        <span className="amount" />)
                                    </span>{" "}
                                </div>
                                <div className="tt_l tt_full fr_name">
                                    {t(this.lang, 'u3_hello')} <span id="user" />
                                </div>
                                <section className="credit">
                                    <div className="credit-box">
                                        <div className="amount-box float-left">
                                            <small>{t(this.lang, 'u3_your_credit')}</small>
                                            <p className="amount" />
                                        </div>
                                        <div className="button-box float-left">
                                            <a
                                                href="/deposit"
                                                className="btn-block btn-gold"
                                            >
                                                <i className="fas fa-wallet" /> {t(this.lang, 'deposit')}
                                            </a>
                                            <a
                                                href="/withdrawal"
                                                className="btn-block btn-silver"
                                            >
                                                <i className="fas fa-hand-holding-usd" /> {t(this.lang, 'withdraw')}
                                            </a>
                                        </div>
                                    </div>
                                </section>
                                <section className="navigation">
                                    <div className="nav-other-button">
                                        <div className="other-list other-list-1">
                                            <a
                                                href="/account"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <i className="fas fa-user" />
                                                <p>{t(this.lang, 'account_info')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-2">
                                            <a
                                                href="/account?h=h"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <i className="fas fa-list-alt" />
                                                <p>{t(this.lang, 'u3_finance_history')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-1">
                                            <a
                                                href="/affiliate"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <i className="fas fa-users" />
                                                <p>{t(this.lang, 'affiliate')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-2">
                                            <a
                                                href="/รางวัลประจำเดือน"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <i className="fas fa-star" />
                                                <p>{t(this.lang, 'u3_monthly_reward')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-1">
                                            <a
                                                href="/เปิดไพ่รับเงินแจกวันละ-5"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <img src="https://ufac4w.com/wp-content/themes/UFAC4.COM/images/card.png" />
                                                <p>{t(this.lang, 'u3_open_card_luck')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-2">
                                            <a
                                                href="/หมุนกงล้อเสี่ยงโชค"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <img src="../wp-content/uploads/2024/07/wheel_back2-edit.png" />
                                                <i className="fas fa-tire" />
                                                <p>{t(this.lang, 'u3_spin_wheel')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-3">
                                            <a
                                                href="/return/"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <i className="fas fa-donate" />
                                                <p> {t(this.lang, 'u3_cashback_credit')}</p>
                                            </a>
                                        </div>
                                        <div className="other-list other-list-4">
                                            <a
                                                href="http://line.me/ti/p/~@ufac4b"
                                                target="_blank"
                                                className="btn-dark-tri hvr-buzz-out"
                                            >
                                                <i className="fab fa-line" />
                                                <p>{t(this.lang, 'u3_contact_staff')}</p>
                                            </a>
                                        </div>
                                    </div>
                                    <div className="nav-play-button hvr-buzz-out ">
                                        <div className="btn-block play-button hvr-buzz-out">
                                            {/* <p> ทางเข้าเล่น UFA11</p> */}
                                            {/* <form method="post" action="https://www.time899.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}
                                            <form
                                                method="post"
                                                action="/login_uf2.php?t=1778007816"
                                                id="form1"
                                                target="_blank"
                                            >
                                                {/* <input type="hidden" name="__EVENTTARGET" value="btnLogin"> */}
                                                <input type="hidden" name="__EVENTARGUMENT" defaultValue="" />
                                                {/* <input type="hidden" name="__VIEWSTATE" value=""> */}
                                                <input
                                                    type="hidden"
                                                    name="url"
                                                    defaultValue="https://www.aster668.com"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATEENCRYPTED"
                                                    id="__VIEWSTATEENCRYPTED"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATEGENERATOR"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="lstLang"
                                                    defaultValue="Default8.aspx?lang=EN-GB"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="txtUserName"
                                                    className="username_"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="password"
                                                    className="password_"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__EVENTVALIDATION"
                                                    defaultValue="aPmuaf/g/FhU9kS+0VX8EHW1LBcFuASzLsl1a+jpPwtj9fjqrCpG4RkO9KHh9d0GulaV0f2KkWXwVZsDTmhkkH0B4sCErKztm7sNaRpbt78ezIN+KawicBiOWvNLbH4RtTLawVZzWGCu0e2uwz9lJ+XgXeekE8WNeaG4zBfBc/NTb7srP14ABKYdpInCQ4aiAFJCUC6JEevRUK6clFgRdI5p4eCqXvEc2uGj7SwjH9JhO0CfUTuvphLSphjFmN29uo3LRlB9aUCrmq4CRnWu44a9x46WX4B0FRygUy5dNyINXZylDiPC/eY5LMtDZy+Hytdhu315GCRpzk3c/qE9hQx0DhuVwF7xr2rfl0M/IC4="
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATE"
                                                    defaultValue="Rp9LorpM7GCUekVZ5BSJK/YkQdp7CupHRLsJesL1tKK2EKiIog1sY1h/n9mg9JlDIjNCx+JA/4TOm2NUb51gKL6tKNQyNNd2533k3yGattwqIfAGspha3HUG8X7bOV6GgtTZpkFbGtjNIx7gLk7tg76wvwEJXoYFMgubQh/eQKgTjIgfdCAWgJTWSv3BiXO04rWvffA6rDCvCiQ0BkJR71Wg+NQSndIkWoT1YESk/UFAp9BnnUUlCHyIwpdVtcuDmftLF0n3OjsUTPOdjFemYO4aObYlWN0zVq0Jl0Sn0IdZcn70Br9r9owsHw4KtO/Hr9dpyN+zmLYb+9u5mgMjD1ZOjrKtDsTNPpFBpKF7F5LFu7tpcODAvFN2EW+CTLkxbZNpASgRLpN0+6ZJrxcSrQ=="
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__EVENTTARGET"
                                                    defaultValue="btnSignIn"
                                                />
                                                <button
                                                    className="tt_l tt_ful fr_submit_bk ufa_link"
                                                    type="submit"
                                                >
                                                    {t(this.lang, 'u3_play_entrance_UFA11')}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="nav-play-button hvr-buzz-out ">
                                        <div className="btn-block play-button hvr-buzz-out">
                                            {/* <p> ทางเข้าเล่น UFA11</p> */}
                                            {/* <form method="post" action="https://www.usa2468.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}
                                            <form
                                                method="post"
                                                action="/login_uf2.php?t=1778007816"
                                                id="form1"
                                                target="_blank"
                                            >
                                                {/* <input type="hidden" name="__EVENTTARGET" value="btnLogin"> */}
                                                <input type="hidden" name="__EVENTARGUMENT" defaultValue="" />
                                                {/* <input type="hidden" name="__VIEWSTATE" value=""> */}
                                                <input
                                                    type="hidden"
                                                    name="url"
                                                    defaultValue="https://www.aster668.com"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATEENCRYPTED"
                                                    id="__VIEWSTATEENCRYPTED"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATEGENERATOR"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="lstLang"
                                                    defaultValue="Default8.aspx?lang=EN-GB"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="txtUserName"
                                                    className="username_"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="password"
                                                    className="password_"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__EVENTVALIDATION"
                                                    defaultValue="aPmuaf/g/FhU9kS+0VX8EHW1LBcFuASzLsl1a+jpPwtj9fjqrCpG4RkO9KHh9d0GulaV0f2KkWXwVZsDTmhkkH0B4sCErKztm7sNaRpbt78ezIN+KawicBiOWvNLbH4RtTLawVZzWGCu0e2uwz9lJ+XgXeekE8WNeaG4zBfBc/NTb7srP14ABKYdpInCQ4aiAFJCUC6JEevRUK6clFgRdI5p4eCqXvEc2uGj7SwjH9JhO0CfUTuvphLSphjFmN29uo3LRlB9aUCrmq4CRnWu44a9x46WX4B0FRygUy5dNyINXZylDiPC/eY5LMtDZy+Hytdhu315GCRpzk3c/qE9hQx0DhuVwF7xr2rfl0M/IC4="
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATE"
                                                    defaultValue="Rp9LorpM7GCUekVZ5BSJK/YkQdp7CupHRLsJesL1tKK2EKiIog1sY1h/n9mg9JlDIjNCx+JA/4TOm2NUb51gKL6tKNQyNNd2533k3yGattwqIfAGspha3HUG8X7bOV6GgtTZpkFbGtjNIx7gLk7tg76wvwEJXoYFMgubQh/eQKgTjIgfdCAWgJTWSv3BiXO04rWvffA6rDCvCiQ0BkJR71Wg+NQSndIkWoT1YESk/UFAp9BnnUUlCHyIwpdVtcuDmftLF0n3OjsUTPOdjFemYO4aObYlWN0zVq0Jl0Sn0IdZcn70Br9r9owsHw4KtO/Hr9dpyN+zmLYb+9u5mgMjD1ZOjrKtDsTNPpFBpKF7F5LFu7tpcODAvFN2EW+CTLkxbZNpASgRLpN0+6ZJrxcSrQ=="
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__EVENTTARGET"
                                                    defaultValue="btnSignIn"
                                                />
                                                <button
                                                    className="tt_l tt_ful fr_submit_bk ufa_link"
                                                    type="submit"
                                                >
                                                    {t(this.lang, 'u3_play_entrance_bk1')}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="nav-play-button hvr-buzz-out ">
                                        <div className="btn-block play-button hvr-buzz-out">
                                            {/* <p> เล่นเดียวนี้ ( สำรอง 1)</p> */}
                                            {/* <form method="post" action="https://www.ugames88.com/HomeSmart.aspx?lang=EN-GB" id="form1" target="_blank" > */}
                                            <form
                                                method="post"
                                                action="/login_uf2.php?t=1778007816"
                                                id="form1"
                                                target="_blank"
                                            >
                                                {/* <input type="hidden" name="__EVENTTARGET" value="btnLogin"> */}
                                                <input type="hidden" name="__EVENTARGUMENT" defaultValue="" />
                                                {/* <input type="hidden" name="__VIEWSTATE" value=""> */}
                                                <input
                                                    type="hidden"
                                                    name="url"
                                                    defaultValue="https://www.ufabet.com"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATEENCRYPTED"
                                                    id="__VIEWSTATEENCRYPTED"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATEGENERATOR"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="lstLang"
                                                    defaultValue="Default8.aspx?lang=EN-GB"
                                                />
                                                <input
                                                    type="hidden"
                                                    name="txtUserName"
                                                    className="username_"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="password"
                                                    className="password_"
                                                    defaultValue=""
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__EVENTVALIDATION"
                                                    defaultValue="aPmuaf/g/FhU9kS+0VX8EHW1LBcFuASzLsl1a+jpPwtj9fjqrCpG4RkO9KHh9d0GulaV0f2KkWXwVZsDTmhkkH0B4sCErKztm7sNaRpbt78ezIN+KawicBiOWvNLbH4RtTLawVZzWGCu0e2uwz9lJ+XgXeekE8WNeaG4zBfBc/NTb7srP14ABKYdpInCQ4aiAFJCUC6JEevRUK6clFgRdI5p4eCqXvEc2uGj7SwjH9JhO0CfUTuvphLSphjFmN29uo3LRlB9aUCrmq4CRnWu44a9x46WX4B0FRygUy5dNyINXZylDiPC/eY5LMtDZy+Hytdhu315GCRpzk3c/qE9hQx0DhuVwF7xr2rfl0M/IC4="
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__VIEWSTATE"
                                                    defaultValue="Rp9LorpM7GCUekVZ5BSJK/YkQdp7CupHRLsJesL1tKK2EKiIog1sY1h/n9mg9JlDIjNCx+JA/4TOm2NUb51gKL6tKNQyNNd2533k3yGattwqIfAGspha3HUG8X7bOV6GgtTZpkFbGtjNIx7gLk7tg76wvwEJXoYFMgubQh/eQKgTjIgfdCAWgJTWSv3BiXO04rWvffA6rDCvCiQ0BkJR71Wg+NQSndIkWoT1YESk/UFAp9BnnUUlCHyIwpdVtcuDmftLF0n3OjsUTPOdjFemYO4aObYlWN0zVq0Jl0Sn0IdZcn70Br9r9owsHw4KtO/Hr9dpyN+zmLYb+9u5mgMjD1ZOjrKtDsTNPpFBpKF7F5LFu7tpcODAvFN2EW+CTLkxbZNpASgRLpN0+6ZJrxcSrQ=="
                                                />
                                                <input
                                                    type="hidden"
                                                    name="__EVENTTARGET"
                                                    defaultValue="btnSignIn"
                                                />
                                                <button
                                                    className="tt_l tt_ful fr_submit_bk ufa_link"
                                                    type="submit"
                                                >
                                                    {t(this.lang, 'u3_play_entrance_bk2')}
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                    <div
                                        id="line_lg_"
                                        style={{ display: "none", background: "#00b900" }}
                                        className="tt_l tt_full b_link_game  hvr-buzz buzz"
                                    >
                                        <a
                                            id="line_lgxx"
                                            href="#"
                                            className="u-btn btn-play btn-block hvr-buzz"
                                        >
                                            <i className="fab fa-line" /> {t(this.lang, 'u3_connect_line_login')}
                                        </a>
                                    </div>
                                    {/* <div class="tt_l tt_full fr_link_2xxx">
<a href="https://sagame6699.com" target="blank_" ><i class="far fa-futbol"></i> SA Gaming</a>
<a href="https://sexygame666.com" target="blank_" ><img src="https://ufac4w.com/wp-content/themes/UFAC4.COM/images/sexy-icon2.png"> เซ็กซี่บาคาร่า</a>
</div> */}
                                    {/* <div class="tt_l tt_full fr_link_2b">
<a href="https://panama888.com" target="blank_" ><img src="https://ufac4w.com/wp-content/themes/UFAC4.COM/images/slotgame-icon.png"> สล็อตออนไลน์ แจกฟรีเครดิต</a>
<a href="https://www.lotto77s.com/" target="blank_" style="width: 100%; font-weight: bold; font-size: clamp(18px, 2.5vw, 30px); box-shadow: inset 0 2px 0 0 #ca9f3d; border-radius: 5px; text-shadow: 0 1px 0 #c29235;"><img src="https://ufac4.com/wp-content/uploads/2021/01/b-all5.png"> ยีกี่ หวยหุ้น หวยลาว หวยรัฐ ไม่มีอั้น</a>
</div> */}
                                    <div className="tt_l tt_full b_logout_game" onclick="logout_();">
                                        <a
                                            href="#"
                                            onclick="logout_();"
                                            className="u-btn btn-play btn-block hvr-buzz"
                                        >
                                            <i className="fas fa-power-off" />
                                            <span> {t(this.lang, 'logout')}</span>
                                        </a>
                                    </div>
                                    <div className="clear" />
                                    <div
                                        className="promo-box tt_l tt_full fr_login center"
                                        style={{ display: "none" }}
                                    >
                                        <img
                                            src="../img/ดาวน์โหลด.jpg"
                                            className="pro-title"
                                            width="100%"
                                        />
                                        <br />
                                        <br />
                                        <table style={{ width: "100%", marginBottom: 15 }}>
                                            <tbody>
                                                <tr style={{ borderBottom: "1pt solid #e0e0e0" }}>
                                                    <td style={{ verticalAlign: "top !important" }}>
                                                        <a href="../kj-r/#ct_from" target="_blank">
                                                            <img src="../ev1010.png" style={{ width: "100%" }} />
                                                        </a>
                                                        <br />
                                                        <center>
                                                            <span className="fr_name">
                                                                ตามหานักเดิมพัน สายเลือดเกาจิ้ง&nbsp;30อันดับ
                                                                ทำกำไรสูงที่สุด แจกเงินรางวัลรวมสูงสุด 30 ล้านบาท
                                                                วันเดียวเท่านั้น ท้าพิสูจน์เกาจิ้งตัวจริง
                                                            </span>
                                                        </center>
                                                        <br />
                                                    </td>
                                                    <td>
                                                        <div className="tt_l tt_full fr_link_r pro-bt">
                                                            <a
                                                                style={{ width: 80 }}
                                                                href="../kj-r/#ct_from"
                                                                target="blank_"
                                                            >
                                                                สมัครเข้าร่วมกิจกรรม{" "}
                                                            </a>{" "}
                                                        </div>
                                                        <div
                                                            className="tt_l tt_full fr_link_r"
                                                            style={{ marginTop: 10 }}
                                                        >
                                                            <a
                                                                style={{ width: 80 }}
                                                                href="javascript:readmore1(1);void(0);"
                                                            >
                                                                รายละเอียด
                                                            </a>{" "}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="promo" />
                                        <table style={{ width: "100%", marginBottom: 15 }}>
                                            <tbody>
                                                <tr style={{ borderBottom: "1pt solid #e0e0e0" }}>
                                                    <td style={{ verticalAlign: "top !important" }}>
                                                        <img src="../pro100.png" style={{ width: "100%" }} />
                                                        <br />
                                                        <center>
                                                            <span className="fr_name">
                                                                โปรโมชั่น!! เทพเจ้าแห่งความผิดหวัง
                                                                แทงบอลเสต็ปตายทั้งบิล 8 คู่ขึ้นไปรับ x100 เท่า
                                                                แทงเท่าไรก็ได้รับทันที
                                                            </span>
                                                        </center>
                                                        <br />
                                                    </td>
                                                    <td>
                                                        {/* <div class="tt_l tt_full fr_link_r pro-bt"><a style="width: 80px;" href="https://line.me/ti/p/~@ufa191a" target="blank_"  >แลกโบนัส</a> </div> */}
                                                        <div
                                                            className="tt_l tt_full fr_link_r"
                                                            style={{ marginTop: 10 }}
                                                        >
                                                            <a
                                                                style={{ width: 80 }}
                                                                href="javascript:readmore5(3);void(0);"
                                                            >
                                                                รายละเอียด
                                                            </a>{" "}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table style={{ width: "100%", marginBottom: 15 }}>
                                            <tbody>
                                                <tr style={{ borderBottom: "1pt solid #e0e0e0" }}>
                                                    <td style={{ verticalAlign: "top !important" }}>
                                                        <img
                                                            src="../wp-content/uploads/2021/01/messageImage_1610623032198.jpg"
                                                            style={{ width: "100%" }}
                                                        />
                                                        <br />
                                                        <center>
                                                            <span className="fr_name">
                                                                แทงถูก หรือ ผิด ติดกัน 10 ตารวด!รับเงินทันที
                                                                <br />
                                                                รับโบนัสทันทีสูงสุดไม่เกิน 5,000 บาท
                                                                อ่านรายละเอียดเพิ่มเติม{" "}
                                                            </span>
                                                        </center>
                                                        <br />
                                                    </td>
                                                    <td>
                                                        <div className="tt_l tt_full fr_link_r pro-bt">
                                                            <a
                                                                style={{ width: 80 }}
                                                                href={this.state.linelink}
                                                                target="blank_"
                                                            >
                                                                แลกโบนัส
                                                            </a>{" "}
                                                        </div>
                                                        <div
                                                            className="tt_l tt_full fr_link_r"
                                                            style={{ marginTop: 10 }}
                                                        >
                                                            <a
                                                                style={{ width: 80 }}
                                                                href="javascript:readmore2(2);void(0);"
                                                            >
                                                                รายละเอียด
                                                            </a>{" "}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table style={{ width: "100%", marginBottom: 15 }}>
                                            <tbody>
                                                <tr style={{ borderBottom: "1pt solid #e0e0e0" }}>
                                                    <td style={{ verticalAlign: "top !important" }}>
                                                        <img
                                                            src="../wp-content/uploads/2023/07/1688277963385.jpg"
                                                            style={{ width: "100%" }}
                                                        />
                                                        <br />
                                                        <center>
                                                            <span className="fr_name">
                                                                เมื่อถึงวันเกิดของท่าน
                                                                เพียงแค่ท่านโชว์บัตรประชาชนให้ทีมงาน
                                                                <br />
                                                                รับทันทีเครดิต 500 บาท (สามารถถอนเงินได้ทันที) <br />
                                                            </span>
                                                        </center>
                                                        <br />
                                                    </td>
                                                    <td>
                                                        <div className="tt_l tt_full fr_link_r pro-bt">
                                                            <a
                                                                style={{ width: 80 }}
                                                                href={this.state.linelink}
                                                                target="blank_"
                                                            >
                                                                แลกโบนัส
                                                            </a>{" "}
                                                        </div>
                                                        <div
                                                            className="tt_l tt_full fr_link_r"
                                                            style={{ marginTop: 10 }}
                                                        >
                                                            <a
                                                                style={{ width: 80 }}
                                                                href="javascript:readmore4(4);void(0);"
                                                            >
                                                                รายละเอียด
                                                            </a>{" "}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default App;
